import classNames from "classnames";
import React, { ReactElement, useContext } from "react";
import { FilterTagProps } from "./filter.types";
import { FilterContext } from "./util/filterContext";

const FilterTag = ({
  className,
  onRemove,
  name,
  label,
  moduleTitle,
  value,
  removeButtonAriaLabel = `Clear ${label} filter`,
  ...rest
}: FilterTagProps): ReactElement => {
  const { isXsScreen } = useContext(FilterContext);
  const containerClasses = classNames(
    "spark-filter__tag",
    { hide: isXsScreen },
    className
  );

  return (
    <div className={containerClasses} data-filter-name={name} {...rest}>
      <span className="spark-filter__tag__label">
        {moduleTitle}
        {moduleTitle && label && " : "}
        {label}
      </span>
      <i
        role="button"
        tabIndex={0}
        aria-label={removeButtonAriaLabel}
        className="spark-icon spark-icon-close spark-filter__tag__close"
        onClick={(e): void => onRemove(e, name, value)}
      ></i>
    </div>
  );
};

export default FilterTag;
